/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Injury_Content_Section_4_HeadingInputs */

const en_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beyond golf`)
};

const es_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más allá del golf`)
};

const de_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über Golf hinaus`)
};

const zh_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高尔夫之外`)
};

const ar_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ما بعد الغولف`)
};

const fr_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Au-delà du golf`)
};

const vi_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngoài golf`)
};

const sw_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaidi ya gofu`)
};

const th_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มากกว่ากอล์ฟ`)
};

const bs_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iza golfa`)
};

const ja_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゴルフを超えて`)
};

const ko_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`골프를 넘어서`)
};

const pt_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Além do golfe`)
};

const it_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oltre il golf`)
};

const sv_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bortom golfen`)
};

const nl_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verder dan golf`)
};

const da_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ud over golf`)
};

const nb_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utover golf`)
};

const fi_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfin ulkopuolella`)
};

const pl_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie tylko golf`)
};

const ru_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не только гольф`)
};

const tr_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfün ötesinde`)
};

const hi_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गोल्फ़ से आगे`)
};

const id_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebih dari golf`)
};

const ms_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melangkaui golf`)
};

const cs_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejen v golfu`)
};

const el_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πέρα από το γκολφ`)
};

const he_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מעבר לגולף`)
};

const af_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verby gholf`)
};

const hu_injury_content_section_4_heading = /** @type {(inputs: Injury_Content_Section_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A golfon túl`)
};

/**
* | output |
* | --- |
* | "Beyond golf" |
*
* @param {Injury_Content_Section_4_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const injury_content_section_4_heading = /** @type {((inputs?: Injury_Content_Section_4_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Injury_Content_Section_4_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_injury_content_section_4_heading(inputs)
	if (locale === "de") return de_injury_content_section_4_heading(inputs)
	if (locale === "zh") return zh_injury_content_section_4_heading(inputs)
	if (locale === "ar") return ar_injury_content_section_4_heading(inputs)
	if (locale === "fr") return fr_injury_content_section_4_heading(inputs)
	if (locale === "vi") return vi_injury_content_section_4_heading(inputs)
	if (locale === "sw") return sw_injury_content_section_4_heading(inputs)
	if (locale === "th") return th_injury_content_section_4_heading(inputs)
	if (locale === "bs") return bs_injury_content_section_4_heading(inputs)
	if (locale === "ja") return ja_injury_content_section_4_heading(inputs)
	if (locale === "ko") return ko_injury_content_section_4_heading(inputs)
	if (locale === "pt") return pt_injury_content_section_4_heading(inputs)
	if (locale === "it") return it_injury_content_section_4_heading(inputs)
	if (locale === "sv") return sv_injury_content_section_4_heading(inputs)
	if (locale === "nl") return nl_injury_content_section_4_heading(inputs)
	if (locale === "da") return da_injury_content_section_4_heading(inputs)
	if (locale === "nb") return nb_injury_content_section_4_heading(inputs)
	if (locale === "fi") return fi_injury_content_section_4_heading(inputs)
	if (locale === "pl") return pl_injury_content_section_4_heading(inputs)
	if (locale === "ru") return ru_injury_content_section_4_heading(inputs)
	if (locale === "tr") return tr_injury_content_section_4_heading(inputs)
	if (locale === "hi") return hi_injury_content_section_4_heading(inputs)
	if (locale === "id") return id_injury_content_section_4_heading(inputs)
	if (locale === "ms") return ms_injury_content_section_4_heading(inputs)
	if (locale === "cs") return cs_injury_content_section_4_heading(inputs)
	if (locale === "el") return el_injury_content_section_4_heading(inputs)
	if (locale === "he") return he_injury_content_section_4_heading(inputs)
	if (locale === "af") return af_injury_content_section_4_heading(inputs)
	if (locale === "hu") return hu_injury_content_section_4_heading(inputs)
	return en_injury_content_section_4_heading(inputs)
});